<script setup lang="ts">
import type { MenuItem } from '~/types/menu/MenuItem'

const mobileMenu = ref(false)
const headerHeight = ref(160)

const route = useRoute()

const menuItems: MenuItem[] = [
  {
    title: 'Home',
    href: '/',
    visible: true
  },
  {
    title: 'Team',
    href: '/team',
    visible: true
  },
  {
    title: 'Leistungen',
    href: '/leistungen',
    visible: true
  },
  {
    title: 'Referenzen',
    href: '/referenzen',
    visible: true
  }
]

defineOptions({
  name: 'HeaderComponent'
})

let rafId: number | null = null

const onScroll = () => {
  if (rafId !== null) return
  rafId = requestAnimationFrame(() => {
    headerHeight.value = window.scrollY <= 0 ? 160 : 80
    rafId = null
  })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
  if (rafId !== null) {
    cancelAnimationFrame(rafId)
  }
})
</script>
<template>
  <div>
    <div>
      <v-app-bar :height="headerHeight" class="lp-header" flat>
        <v-container class="maxWidth py-sm-4 py-0">
          <v-toolbar class="d-flex align-center bg-white">
            <div>
              <Logo />
            </div>
            <div class="ml-auto d-lg-flex d-none">
              <Navigation :items="menuItems" :active="route.path" />
            </div>
            <div class="hidden-lg-and-up ml-auto mr-4">
              <button
                type="button"
                class="menu-wrapper"
                :class="{ active: mobileMenu }"
                :aria-expanded="mobileMenu"
                aria-label="Navigation"
                @click.stop="mobileMenu = !mobileMenu"
              >
                <div class="menu-bar one" aria-hidden="true"></div>
                <div class="menu-bar two" aria-hidden="true"></div>
                <div class="menu-bar three" aria-hidden="true"></div>
              </button>
            </div>
          </v-toolbar>
        </v-container>
      </v-app-bar>
      <nav
        v-if="mobileMenu"
        class="mobile-menu-container"
        aria-label="Hauptnavigation"
        :style="`margin-top:${headerHeight}px;`"
      >
        <template v-for="item of menuItems" :key="item.title">
          <div v-if="item.visible" class="mobile-menu-items-container">
            <NuxtLink
              :to="item.href"
              class="mobile-menu-item text-body text-h5 mb-6"
              :class="{ 'text-primary': item.href === route.path }"
              :aria-current="item.href === route.path ? 'page' : undefined"
              >{{ item.title }}</NuxtLink
            >
          </div>
        </template>
      </nav>
    </div>
  </div>
</template>

<style scoped lang="scss">
.bg-white {
  background-color: #fff;
}

.mobile-menu-container {
  position: fixed;
  z-index: 1000;
}

.mobile-menu-items-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  width: 100vw;
}

.mobile-menu-item {
  text-align: center;
  color: #000;
  text-decoration: none;
  transition: all 0.3s;
}

.menu-wrapper {
  width: 44px;
  height: 44px;
  padding: 9px;
  cursor: pointer;
  position: relative;
  background: none;
  border: none;
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-bar {
  position: absolute;
  width: 26px;
  height: 2px;
  background: #000;
  left: 9px;
}

// eslint-disable-next-line vue-scoped-css/no-unused-selector
.menu-wrapper:hover .menu-bar.active {
  animation: none;
}
.active .one {
  top: 50%;
  left: 9px;
  transform: rotate(45deg);
}

.active .two {
  opacity: 0;
  transition: all 0.3s;
}

.active .three {
  top: 50%;
  left: 9px;
  transform: rotate(-45deg);
}

.one {
  top: 14px;
  animation-delay: 0.1s;
  transition: all 0.3s;
}

.two {
  top: 21px;
  opacity: 1;
  transition: all 0.3s;
}

.three {
  top: 28px;
  transition: all 0.3s;
}
</style>
